import React, { useEffect, useState } from "react";
import axios from "../../../api/axios";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function PendingVariations() {
  const [variations, setVariations] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const extractRows = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.data)) return payload.data.data;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.results)) return payload.results;
    return [];
  };

  useEffect(() => {
    const fetchVariations = async () => {
      try {
        const response = await axios.get("/variations/pending");
        setVariations(extractRows(response.data));
      } catch (error) {
        console.error("Error fetching variations:", error);
        setVariations([]);
      }
    };

    fetchVariations();
  }, []);

  const filteredVariations = variations.filter((v) => {
    const searchText = search.toLowerCase();

    const fullText = [
      v?.pfno,
      v?.pf_no,
      v?.staff?.surname,
      v?.staff?.firstname,
      v?.staff?.first_name,
      v?.staff?.othername,
      v?.staff?.other_name,
      v?.staff_name,
      v?.category,
      v?.status,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return fullText.includes(searchText);
  });

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={2} sx={{ p: 2, width: "100%", maxWidth: "100%" }}>
        <Grid item xs={12}>
          <TextField
            label="Search variations..."
            variant="outlined"
            size="small"
            fullWidth
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(0);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: 3,
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Table
              size="small"
              stickyHeader
              sx={{
                minWidth: 1100,
                tableLayout: "auto",
                "& th": {
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  fontSize: "0.85rem",
                },
                "& td": {
                  whiteSpace: "nowrap",
                  fontSize: "0.85rem",
                  verticalAlign: "middle",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 70 }}>S/N</TableCell>
                  <TableCell sx={{ width: 120 }}>PF No</TableCell>
                  <TableCell sx={{ width: 150 }}>Surname</TableCell>
                  <TableCell sx={{ width: 150 }}>Firstname</TableCell>
                  <TableCell sx={{ width: 150 }}>Othername</TableCell>
                  <TableCell sx={{ width: 180 }}>Category</TableCell>
                  <TableCell sx={{ width: 180 }}>Old Value</TableCell>
                  <TableCell sx={{ width: 180 }}>New Value</TableCell>
                  <TableCell sx={{ width: 120 }}>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredVariations
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((v, index) => (
                    <TableRow key={v.id || index} hover>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{v.pfno || v.pf_no || "-"}</TableCell>
                      <TableCell>{v.staff?.surname || "-"}</TableCell>
                      <TableCell>{v.staff?.firstname || v.staff?.first_name || "-"}</TableCell>
                      <TableCell>{v.staff?.othername || v.staff?.other_name || "-"}</TableCell>
                      <TableCell>{v.category || "-"}</TableCell>
                      <TableCell>{v.old_value || "-"}</TableCell>
                      <TableCell>{v.new_value || "-"}</TableCell>
                      <TableCell>{v.status || "-"}</TableCell>
                    </TableRow>
                  ))}

                {filteredVariations.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No pending variations found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={filteredVariations.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[50, 100, 200]}
          />
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}
